<template>
  <div id="app">
    <app-header :title="title"></app-header>
    <router-view :key="key" :host="host" @titleChanged="updateTitle($event)"></router-view>
    <app-footer></app-footer>
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  import mdui from 'mdui'

  export default {
    name: 'App',
    data(){
      return {
        title: "index",
        host: "https://api.endcloud.cn/yys_web/"
      }
    },
    components:{
      'app-header': Header,
      'app-footer': Footer,
    },
    methods:{
      updateTitle(e){
        this.title = e
      },
      baidu(){
        let _hmt = _hmt || [];
        (function() {
          let hm = document.createElement("script");
          hm.src = "https://hm.baidu.com/hm.js?1557b58c929e06d69a183fbea33490a5";
          let s = document.getElementsByTagName("script")[0];
          s.parentNode.insertBefore(hm, s);
        })();
      },
      setCookie(name,value){
        let Days = 1000;
        let exp = new Date();
        exp.setTime(exp.getTime() + Days*24*60*60*1000);
        document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString();
      },
      tips(){
        let cookie = document.cookie;
        if(cookie.indexOf("new2.0=yes")>0){
          this.setCookie("new2.0", "yes");
        }else{
          let vue = this;
          vue.setCookie("new2.0", "yes");
          this.$dialog
                  .alert('全新版本，敬请享用^_^<br>有问题记得联系我。', {html: true, okText: '确定'})
                  .then(function(dialog) {
                    // console.log('Closed');
                    // vue.setCookie("new2.0", "yes");
                  });
        }
      }
    },
    computed:{
      key(){
        return this.$route.path + Math.random();
      }
    },
    mounted() {
      this.baidu();
      // this.tips();
    }
  }
</script>

<style>
  #app {
    font-family: 'PingFang SC', 'Microsoft YaHei', 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
  #main-content{
    margin-top: 5rem;
    /*margin-bottom: 5rem;*/
  }
</style>



// WEBPACK FOOTER //
// src/App.vue